export default "assets/images/icons/cart-75b59ab8.svg";